<sbf-error-shell [errorNumber]="503" message1="THE SERVER IS TEMPORARILY UNABLE TO SERVICE YOUR REQUEST DUE TO MAINTENANCE DOWNTIME OR CAPACITY PROBLEMS" message2="PLEASE TRY AGAIN LATER"></sbf-error-shell>
